module.exports = __webpack_public_path__ + "static/real-time-planning-2dc1949dc94f1e102fa83ffc13cf8151.png";